<template>
  <div class="box">
    <div class="vr">
      <div class="body">
        <div class="left">
          <div class="title">{{ $t('homePage.vr.title') }}</div>

          <div class="english">
            <span>China</span>
            <span>Coal</span>
            <span>&</span>
            <span>Mining</span>
            <span>Expo</span>
            <span>2023</span>
          </div>

          <div class="txt">
            {{ $t('homePage.vr.txt') }}
          </div>
        </div>
        <div class="right">
          <router-link to="#">
            <img src="../../static/vrCloudChinese.png" alt="" @click="jumpVr()" class="backImg" v-if="lang == 'zh'" />
            <img src="../../static/vrCloudChinese.png" alt="" class="backImg" @click="jumpVr()" v-else />
            <img src="../../static/btnVR.png" alt="" @click="jumpVr()" class="VRbtn" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testDomain } from '../../../utils/common';
export default {
  name: 'vrSee',
  data() {
    return {
      lang: 'zh',
      testBaseDomain: testDomain(),
    };
  },
  created() {
    this.lang = localStorage.getItem('lang');
  },
  methods: {
    jumpVr() {
      window.open(this.testBaseDomain + 'index?slanguage=' + this.lang);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f6f6f7;
  height: 476px;
  .vr {
    width: 100%;
    height: 459px;
    background-image: url('../../static/VR.png');
    .body {
      width: 1270px;
      height: 459px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        height: fit-content;
        padding-left: 50px;
        box-sizing: border-box;
        padding-right: 88px;

        .title {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fdd72a;
          line-height: 42px;
        }
        .english {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fdd72a;
          line-height: 42px;
          span {
            margin: 0px 3px;
          }
        }
        .txt {
          padding-top: 25px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
      }

      .right {
        width: 620px;
        height: 414px;
        margin-top: 80px;
        z-index: 10;
        position: relative;
        .backImg {
          width: 100%;
          height: 100%;
          z-index: 10;
        }
        .VRbtn {
          width: 53px;
          height: 65px;
          z-index: 10;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
